import { render } from "./AlertsSidebar.vue?vue&type=template&id=40879fbc&scoped=true"
import script from "./AlertsSidebar.vue?vue&type=script&lang=js"
export * from "./AlertsSidebar.vue?vue&type=script&lang=js"

import "./AlertsSidebar.vue?vue&type=style&index=0&id=40879fbc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40879fbc"]])

export default __exports__